export default "__VITE_PUBLIC_ASSET__91a68e25__"